import React, { useState } from "react";
import { FaChevronUp } from "react-icons/fa";

const BoxWrapper = ({ title, children, defaultExpanded = true }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className="relative bg-white rounded-xl p-6 w-full">
      {/* Header with title + toggle */}
      <div className="flex justify-between items-center pr-3">
        <span className="text-2xl font-thin text-stone-900 ">{title}</span>
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="text-gray-500 hover:text-black transition-transform"
        >
          <FaChevronUp
            className={`transform transition-transform duration-300 ${
              !expanded ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>

      {/* Collapsible content */}
      <div
        className={`transition-all duration-300 ease-in-out ${
          expanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default BoxWrapper;